/* GASSISA
 * Barra slim de estatus de impresión para el módulo de etiquetado.
 * Una sola línea discreta: PrinterTools + impresora a usar, con
 * semáforo. El detalle completo vive en tooltips.
 */

import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';

function Pildora({ dotColor, texto, tip, maxWidth = 260 }) {
    return (
        <Tooltip title={tip}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px', minWidth: 0 }}>
                <Box
                    sx={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: dotColor,
                        flexShrink: 0,
                    }}
                />
                <Box
                    component="span"
                    sx={{
                        fontSize: '0.75rem',
                        color: '#555',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth,
                    }}
                >
                    {texto}
                </Box>
            </Box>
        </Tooltip>
    );
}

export default function CardEstatusImpresoraEtiquetado({
    estadoPrinterTools,
    estadoImpresora,
    onReintentar,
    verificando = false,
    esAlternativa = false,
}) {
    const toolsEnLinea = estadoPrinterTools?.enLinea === true;
    const toolsColor = estadoPrinterTools?.verificando ? '#F9A825' : (toolsEnLinea ? '#2E7D32' : '#D32F2F');
    const toolsTexto = estadoPrinterTools?.verificando
        ? "PT…"
        : (toolsEnLinea
            ? `PT · ${estadoPrinterTools?.nombreEquipo || "en línea"}`
            : "PT sin conexión");
    const toolsTip = estadoPrinterTools?.verificando
        ? "Verificando PrinterTools..."
        : (toolsEnLinea
            ? `PrinterTools en línea${estadoPrinterTools?.nombreEquipo ? ` en ${estadoPrinterTools.nombreEquipo}` : ""}`
            : "PrinterTools no responde en localhost:4000");

    const impVerificando = estadoImpresora?.verificando === true;
    const impLista = estadoImpresora?.canPrint === true;
    const impColor = impVerificando ? '#F9A825' : (impLista ? '#2E7D32' : '#D32F2F');
    const impNombre = estadoImpresora?.printerName || "Sin impresora";
    const impCodigo = estadoImpresora?.statusCode && estadoImpresora.statusCode !== "UNKNOWN"
        ? ` · ${estadoImpresora.statusCode}`
        : "";
    const impTexto = impVerificando ? "Impresora…" : `${impNombre}${impLista ? "" : impCodigo}`;
    const impTip = impVerificando
        ? "Verificando impresora..."
        : (`${estadoImpresora?.message || "Estado no disponible"}` +
            (impLista ? "" : " — etiquetado deshabilitado hasta que esté disponible"));

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                flexWrap: 'wrap',
                px: 1,
                py: '4px',
                mb: 1,
                border: '1px solid #ECECEC',
                borderRadius: 1,
                backgroundColor: '#FAFAFA',
            }}
        >
            <Pildora dotColor={toolsColor} texto={toolsTexto} tip={toolsTip} maxWidth={180} />
            <Box sx={{ width: '1px', height: '14px', backgroundColor: '#E0E0E0' }} />
            <Pildora dotColor={impColor} texto={impTexto} tip={impTip} maxWidth={300} />
            {esAlternativa && (
                <Chip label="alt" size="small" variant="outlined" sx={{ height: '18px', fontSize: '0.65rem' }} />
            )}
            <Box sx={{ flexGrow: 1 }} />
            <Tooltip title="Revalidar estado">
                <span>
                    <IconButton onClick={onReintentar} disabled={verificando || impVerificando} size="small" sx={{ p: '2px' }}>
                        <RefreshIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
}
